module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxwYXRoIGQ9Ik04IDJMMTAuMzA0MSA1LjgyODY1TDE0LjY1NzQgNi44MzY4OEwxMS43MjgxIDEwLjIxMTNMMTIuMTE0NSAxNC42NjMxTDggMTIuOTJMMy44ODU1IDE0LjY2MzFMNC4yNzE4NiAxMC4yMTEzTDEuMzQyNiA2LjgzNjg4TDUuNjk1ODggNS44Mjg2NUw4IDJaIiBmaWxsPSIjRjZDODI2IiBzdHJva2U9IiNGNkM4MjYiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4NCjwvc3ZnPg0K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/classroomObservation/collect2.svg
// module id = KUJe
// module chunks = 4